exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail-dates__author[data-v-38c7609e]{margin-top:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38c7609e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/AdminDetail.vue
// module id = 801
// module chunks = 0